'use client';

import React, { Fragment, RefObject, useCallback, useEffect, useState, JSX, FC } from 'react';
import useScrollSlide from '@/Hooks/useScrollSlide';
import { ApiClimateArea, ApiClimateInfo, ApiClimateInfoFromJSON } from '../../../api/model';
import { Next, Previous } from '@/Theme/SVG/Svgs';
import MobileListItem from '@/components/climateTable/MobileListItem';

const ITEM_INDEX_TOLERANCE = 0.02;
let timer: ReturnType<typeof setTimeout> | null = null;

const ClimateTableScroll: FC<{ climateArea: ApiClimateArea }> = ({ climateArea }): JSX.Element => {
  const [outerContainerMeasures, setOuterContainerMeasures] = useState<DOMRect | null>(null);

  useEffect(() => {
    return () => {
      if (!!timer) {
        clearTimeout(timer);
      }
    };
  }, []);

  const scroll = useCallback(
    (toLeft: boolean, outerContainer: RefObject<HTMLDivElement>): void => {
      if (!outerContainer.current) return;
      const containerWidth = outerContainerMeasures?.width || 1;
      const itemIndex = outerContainer.current.scrollLeft / containerWidth;
      const itemIndexRounded = Math.floor(itemIndex);
      const scrollToPosition = toLeft
        ? (itemIndexRounded -
            (itemIndex - itemIndexRounded >= 0 &&
            itemIndex - itemIndexRounded < ITEM_INDEX_TOLERANCE
              ? 1
              : 0)) *
          containerWidth
        : containerWidth *
          (itemIndexRounded +
            (Math.ceil(itemIndex) - itemIndex > 0 &&
            Math.ceil(itemIndex) - itemIndex < ITEM_INDEX_TOLERANCE
              ? 2
              : 1));
      outerContainer.current.scrollTo({
        left: scrollToPosition,
        behavior: 'smooth'
      });
    },
    [outerContainerMeasures]
  );

  const { outerContainer, Buttons } = useScrollSlide(
    (outerContainer): void => {
      const setMeasures = (): void => {
        if (!!outerContainer?.current) {
          setOuterContainerMeasures(outerContainer.current.getBoundingClientRect());
        }
      };
      setMeasures();
      timer = setTimeout(setMeasures, 500);
    },
    scroll,
    [
      { class: 'navBtn--prev', icon: <Previous /> },
      { class: 'navBtn--next', icon: <Next /> }
    ]
  );

  return (
    <div className="position-relative d-flex overflow-hidden">
      <div ref={outerContainer} className="climate-table__swipe-container">
        <div className="climate-table__swipe-wrapper">
          {!!climateArea?.climateInfos &&
            climateArea.climateInfos.map((climateInfo: ApiClimateInfo, idx: number) =>
              idx % 2 === 0 ? (
                <MobileListItem
                  key={climateInfo.name}
                  globalIdx={idx}
                  months={[
                    climateInfo,
                    ApiClimateInfoFromJSON({
                      ...(climateArea.climateInfos?.[idx + 1] || {})
                    })
                  ]}
                  outerContainerMeasures={outerContainerMeasures}
                />
              ) : (
                <Fragment key={climateInfo.name}></Fragment>
              )
            )}
        </div>
      </div>
      {Buttons}
    </div>
  );
};
export default ClimateTableScroll;
